<template>
  <div id="app">

    <router-view />

  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {},
  mounted() {
    this.lang = localStorage.getItem('lang') || 'zh'
  },
}
</script>
<style>
html,
body {
  height: 100%;
}
#app {
  font-size: 14px;
  height: 100%;
}
</style>
